(function () {
  'use strict';

  angular
    .module('mapPairingGroups')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('mapPairingGroups', {
        url: '/map-pairing-groups',
        views: {
          'mapPairingGroupsView': {
            templateUrl: 'map-pairing-groups/views/map-pairing-groups.tpl.html',
            controller: 'MapPairingGroupsCtrl',
            controllerAs: 'mapPairingGroups'
          }
        }
      });
  }
}());
